// import legislationQyList from '../components/noticeQy/legislationQyList.vue'
// import noticeQyList from '../components/noticeQy/noticeQyList.vue'
// import viewLegislationQy from '../components/noticeQy/viewLegislationQy.vue'
// import viewNoticeQy from '../components/noticeQy/viewNoticeQy.vue'
// import trainDataQyList from '../components/noticeQy/trainDataQyList.vue'
// import viewTrainDataQy from '../components/noticeQy/viewTrainDataQy.vue'
// import newsQyList from '../components/noticeQy/newsQyList.vue'

export default [
    {
        path: 'noticeQy/legislationQyList',
        component: resolve => require(['@/components/noticeQy/legislationQyList'],resolve),
        name:"LegislationQyList",
        meta:{
            id:'712',
            node:'noticeQy',
            url:'legislationQyList',
        }
    },
    {
        path: 'noticeQy/noticeQyList',
        component: resolve => require(['@/components/noticeQy/noticeQyList'],resolve),
        name:"NoticeQyList",
        meta:{
            id:'710',
            node:'noticeQy',
            url:'noticeQyList',
        }
    },
    {
        path: 'noticeQy/viewLegislationQy',
        component: resolve => require(['@/components/noticeQy/viewLegislationQy'],resolve),
        name:"ViewLegislationQy",
        meta:{
            id:'713',
            node:'noticeQy',
            url:'viewLegislationQy',
        }
    },
    {
        path: 'noticeQy/viewNoticeQy',
        component: resolve => require(['@/components/noticeQy/viewNoticeQy'],resolve),
        name:"ViewNoticeQy",
        meta:{
            id:'711',
            node:'noticeQy',
            url:'viewNoticeQy',
        }
    },
    {
        path: 'noticeQy/trainDataQyList',
        component: resolve => require(['@/components/noticeQy/trainDataQyList'],resolve),
        name:"TrainDataQyList",
        meta:{
            id:'778',
            node:'noticeQy',
            url:'trainDataQyList',
        }
    },
    {
        path: 'noticeQy/viewTrainDataQy',
        component: resolve => require(['@/components/noticeQy/viewTrainDataQy'],resolve),
        name:"ViewTrainDataQy",
        meta:{
            id:'779',
            node:'noticeQy',
            url:'viewTrainDataQy',
        }
    },
    {
        path: 'noticeQy/newsQyList',
        component: resolve => require(['@/components/noticeQy/newsQyList'],resolve),
        name:"NewsQyList",
        meta:{
            id:'796',
            node:'noticeQy',
            url:'newsQyList',
            isChange: false,
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/noticeQy.js